import { useApiClient } from "../apiClients";
import { GRADES_ENDPOINTS } from "./endpoints";
import type { Grade } from "../../models/domain";

export type ListGradesParams = {
  stage_id: string;
  code?: string;
  limit?: number;
  offset?: number;
  sort?: string;
};

export type CreateGradePayload = Omit<
  Grade,
  "id" | "created_at" | "updated_at"
>;

export type UpdateGradePayload = Partial<CreateGradePayload>;

export const useGradesApi = () => {
  const apiClient = useApiClient("embed");

  const listGrades = (params: ListGradesParams) =>
    apiClient.get<Grade[]>(GRADES_ENDPOINTS.BASE, { params });

  const getGrade = (gradeId: string) =>
    apiClient.get<Grade>(GRADES_ENDPOINTS.DETAIL(gradeId));

  const createGrade = (payload: CreateGradePayload) =>
    apiClient.post<Grade>(GRADES_ENDPOINTS.BASE, payload);

  const updateGrade = (gradeId: string, payload: UpdateGradePayload) =>
    apiClient.put<Grade>(GRADES_ENDPOINTS.DETAIL(gradeId), payload);

  const deleteGrade = (gradeId: string) =>
    apiClient.delete<void>(GRADES_ENDPOINTS.DETAIL(gradeId));

  return { listGrades, getGrade, createGrade, updateGrade, deleteGrade };
};
